export default "__VITE_ASSET__DyeOFAUX__"